import React from "react"
import Image from "./image"

const Stores = () => (
  <div className="stores">
    <div className="columns">
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/hinoyacurry.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/kinniku_shokudo.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/gapaoshokudo.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/frijoles.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/ts.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/tacorico.png" />
          </div>
        </div>
      </div>
    </div>
    <div className="columns columns2">
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/highfive.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/beefman.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image">
            <Image filename="restaurant/cosicosi.png" />
          </div>
          <div className="image">
            <Image filename="restaurant/itadaki.png" />
          </div>
        </div>
      </div>
      <div className="column">
        <div className="logos">
          <div className="image image1">
            <Image filename="restaurant/vingo.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Stores
